import { render, staticRenderFns } from "./TabelaTurma.vue?vue&type=template&id=a34d882a&scoped=true&"
import script from "./TabelaTurma.vue?vue&type=script&lang=js&"
export * from "./TabelaTurma.vue?vue&type=script&lang=js&"
import style0 from "./TabelaTurma.vue?vue&type=style&index=0&id=a34d882a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34d882a",
  null
  
)

export default component.exports